class IcsQuestionnaireModalController {
    constructor(toastr) {
        this.$onInit = () => {
            this.userId = this.resolve.userId;
            this.simId = this.resolve.simId;
            this.testSuiteId = this.resolve.testSuiteId;
            this.readOnly = this.resolve.readOnly;
            this.userName = this.resolve.userName;
            this.simulatorName = this.resolve.simulatorName;
        };
        this.toastr = toastr;
    }
}
angular.module('app').component('icsQuestionnaireModal', {
    bindings: {
        resolve: '<',
        close: '&',
        dismiss: '&'
    },
    templateUrl: 'scripts/app/partials/ICS/ics-questionnaire-modal.tpl.html',
    controllerAs: 'vm',
    controller: IcsQuestionnaireModalController
});
